module.exports = __webpack_public_path__ + "img/thanks-letter.5288e5ab.png";